import React from 'react';

import {
  PLATFORM_MODE_REBATE, PLATFORM_MODE_TRADE, TRADE_DIRECTION_BUY,
  TRADE_DIRECTION_SELL,
} from 'src/util/constants';
import { getTradeDirectionAction } from 'src/util/i18n/helpers';

/**
 * Generates the introduction text for the clause list TOU.
 * @param {object} params - Function parameters
 * @param {import('react-intl').IntlShape} params.intl - React Intl internationalization object
 *   for formatting messages
 * @param {TRADE_DIRECTION_BUY | TRADE_DIRECTION_SELL | string} params.direction - Trade
 *   direction from GraphQL schema (TRADE_DIRECTION_BUY or TRADE_DIRECTION_SELL)
 * @param {PLATFORM_MODE_REBATE|PLATFORM_MODE_TRADE} params.mode - Platform operating
 *   mode determining price display format (rebate shows discounts, trade shows prices)
 * @returns {React.ReactElement|React.ReactNode[]|string|null} Returns FormattedMessage JSX element
 */
const buildClauseListTOUIntro = ({
  intl, direction, mode,
}) => {
  const tradeDirection = getTradeDirectionAction(intl, direction);
  const rebateIntro = intl.formatMessage(
    {
      id: 'trade_rule.trade_rule_timeline.helpers.trade_rule.clause_list_tou_rebate_intro.text',
      defaultMessage: '{tradeDirection} at a discount of:',
    },
    {
      tradeDirection: <strong>{tradeDirection}</strong>,
    },
  );

  const intro = intl.formatMessage(
    {
      id: 'trade_rule.trade_rule_timeline.helpers.trade_rule.clause_list_tou_intro.text',
      defaultMessage: '{tradeDirection} at:',
    },
    {
      tradeDirection: <strong>{tradeDirection}</strong>,
    },
  );
  return mode === PLATFORM_MODE_REBATE ? rebateIntro : intro;
};

export default buildClauseListTOUIntro;
